import { render, staticRenderFns } from "./radio-grid.vue?vue&type=template&id=746219e2&scoped=true&lang=pug&"
import script from "./radio-grid.vue?vue&type=script&lang=js&"
export * from "./radio-grid.vue?vue&type=script&lang=js&"
import style0 from "./radio-grid.vue?vue&type=style&index=0&id=746219e2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "746219e2",
  null
  
)

/* custom blocks */
import block0 from "~/lang/formFields?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Fubuntu%2Fnuxt%2Fbonkers%2Freleases%2F20231002092431%2Fcomponents%2Fwidgets%2Fforms%2Fradio-grid.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports